import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionWithChangeLogComponent } from './version-with-change-log.component';
import { VERSION_INFO } from './version-with-change-log.injections';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [VersionWithChangeLogComponent],
  exports: [
    VersionWithChangeLogComponent
  ]
})
export class VersionWithChangeLogModule {
  static forRoot(version_info: {
      "dirty": boolean,
      "raw": string,
      "hash": string,
      "distance": any,
      "tag": any,
      "semver": any,
      "suffix": string,
      "semverString": any,
      "version": string
  }) {
    return {
      ngModule: VersionWithChangeLogModule,
      providers: [
        { provide: VERSION_INFO, useValue: version_info },
      ],
    }    
  }
}


